import { render, staticRenderFns } from "./MailingsMessageDetails.vue?vue&type=template&id=40b28e54&scoped=true&"
import script from "./MailingsMessageDetails.vue?vue&type=script&lang=ts&"
export * from "./MailingsMessageDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b28e54",
  null
  
)

export default component.exports